<template>
  <div class="response-viewer">
    <a-card title="模型响应" size="small">
      <pre v-if="formattedResponse" class="json-display">{{ formattedResponse }}</pre>
      <div v-else style="color: #999; text-align: center; padding: 16px">
        暂无响应
      </div>
    </a-card>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'ResponseViewer',
  props: {
    response: {
      type: [Object, String],
      default: null
    }
  },
  setup(props) {
    const formattedResponse = computed(() => {
      if (!props.response) return '';

      if (typeof props.response === 'string') {
        // 尝试解析JSON
        try {
          const parsed = JSON.parse(props.response);
          return JSON.stringify(parsed, null, 2);
        } catch (e) {
          // 如果不是JSON，直接返回
          return props.response;
        }
      } else if (typeof props.response === 'object') {
        return JSON.stringify(props.response, null, 2);
      }

      return String(props.response);
    });

    return {
      formattedResponse
    };
  }
};
</script>

<style scoped>
.response-viewer {
  margin-bottom: 16px;
}

.json-display {
  background: #f5f5f5;
  padding: 12px;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.6;
  overflow-x: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-height: 400px;
  overflow-y: auto;
}
</style>

